import React from "react";

const AboutDiksha = () => {
  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-lg-5 mb-5 mb-lg-0" style={{ minHeight: "500px" }}>
          <div className="position-relative h-100">
            <img
              className="position-absolute w-100 h-100"
              src="img/welcome_to_diksha.png"
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
        <div className="col-lg-7">
          <div className="">
            <h6 className="section-title bg-white text-start text-primary pe-3">
              Welcome To Diksha SEA
            </h6>
            {/* <h1 className="mb-4">Your Pathway to a Successful IT Career!</h1> */}
            <h1
              className="mb-4"
              style={{ fontSize: "28px", fontWeight: "bold" }}
            >
              Your Pathway to a Successful IT Career at Diksha SEA – Leading
              Software & IT Training Institute in Tirupati
            </h1>
          </div>
          <p className="mb-4" style={{ fontFamily: "Nunito" }}>
            At DikshaSea, we recognize the rapid changes in the IT industry and
            the growing demand for skilled professionals. Our goal is to provide
            you with the essential tools, practical experience, and
            industry-recognized certifications to help you succeed in the tech
            world. Whether you're just starting your IT career or aiming to
            enhance your existing skills, our comprehensive courses are
            specifically designed to prepare you for the challenges and
            opportunities of today’s competitive job market.
          </p>
          <div className="row pt-3 mx-0">
            <div className="col-6 col-md-3 px-0">
              <div className="bg-success text-center p-4">
                <h1 className="text-white" data-toggle="counter-up">
                  30+
                </h1>
                <h6 className="text-uppercase text-white">
                  Available<span className="d-block">Subjects</span>
                </h6>
              </div>
            </div>
            <div className="col-6 col-md-3 px-0">
              <div className="bg-primary text-center p-4">
                <h1 className="text-white" data-toggle="counter-up">
                  20+
                </h1>
                <h6 className="text-uppercase text-white">
                  Online<span className="d-block">Courses</span>
                </h6>
              </div>
            </div>
            <div className="col-6 col-md-3 px-0">
              <div className="bg-secondary text-center p-4">
                <h1 className="text-white" data-toggle="counter-up">
                  10+
                </h1>
                <h6 className="text-uppercase text-white">
                  Skilled<span className="d-block">Instructors</span>
                </h6>
              </div>
            </div>
            <div className="col-6 col-md-3 px-0">
              <div className="bg-warning text-center p-4">
                <h1 className="text-white" data-toggle="counter-up">
                  1234
                </h1>
                <h6 className="text-uppercase text-white">
                  Happy<span className="d-block">Students</span>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutDiksha;
